import type { PublicCombineMeasurementResponseRecord } from '@on3/api';
import { Text } from 'components/UI/Typography/Text';
import useAthlete from 'contexts/AthleteProvider';

import styles from './CombineData.module.scss';
import { CombineDataItem } from './CombineDataItem';

interface ICombineDataModule {
  combineData: PublicCombineMeasurementResponseRecord[];
}
export const CombineDataModule = ({ combineData }: ICombineDataModule) => {
  const { athlete } = useAthlete();
  const affiliation = athlete?.defaultSport?.key === 1 ? 'NFL' : 'NBA';

  return (
    <section className={styles.combineDataWrapper}>
      <header>
        <Text className={styles.title} variant="overline">
          {affiliation} combine data
        </Text>
      </header>

      <ul className={styles.combineList}>
        {combineData.map((measurement) => {
          return (
            <CombineDataItem
              {...measurement}
              key={measurement.measurementTypeKey}
            />
          );
        })}
      </ul>
    </section>
  );
};
